import Component from '../Component';
/**
 * The `AlertManager` component provides an area in which `Alert` components can
 * be shown and dismissed.
 */
export default class AlertManager extends Component {
  oninit(vnode) {
    super.oninit(vnode);
    this.state = this.attrs.state;
  }
  view() {
    var _this = this;
    const activeAlerts = this.state.getActiveAlerts();
    return m("div", {
      className: "AlertManager"
    }, Object.keys(activeAlerts).map(Number).map(key => {
      const alert = activeAlerts[key];
      const urgent = alert.attrs.type === 'error';

      // Dismissing has to remove the alert from the list, which is the
      // manager's bookkeeping and not the caller's to replace. Whatever
      // the caller passed runs as well: an extension may need to know its
      // alert was dismissed — to remember the reader declined, say — and
      // overwriting `ondismiss` outright is why it never heard about it.
      const ondismiss = function () {
        for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }
        alert.attrs.ondismiss?.(...args);
        _this.state.dismiss(key);
      };
      return m("div", {
        className: "AlertManager-alert",
        role: "alert",
        "aria-live": urgent ? 'assertive' : 'polite'
      }, m(alert.componentClass, Object.assign({}, alert.attrs, {
        ondismiss: ondismiss
      }), alert.children));
    }));
  }
}
flarum.reg.add('core', 'common/components/AlertManager', AlertManager);